import React from "react";
import {connect} from "react-redux";
import VeritasHeader from "../../shared/VeritasHeader";
import {Button, Confirm, Grid, Modal, Popup} from "semantic-ui-react";
import {
    deleteDataProvider,
    fetchAllOrganizations,
    fetchOneDataProvider,
    toggleDeleteWarning,
    unmountDataProviderDetail
} from "../actions/DataProviderActions";
import ProviderDetailInfo from "./ProviderDetailInfo";
import {fetchAllServices} from "../../data-services/actions/ServicesActions";
import {closeAddEditModal, openEditModal} from "../../add-edit/actions/AddEditActions";
import DataProviderForm from "../../add-edit/components/DataProviderForm";
import * as Validation from "../../../common/utils/Validation";
import {updatedDPRefresh, validateDataProvider} from "../../add-edit/actions/AddEditDPActions";
import {toggleApproval} from "../../../middlewares/veritas-middleware/actions/UtilityMiddlewareActions";
import Breadcrumb from "../../../common/partials/Breadcrumb";
import { setBreadCrumb } from "../../breadcrumb/BreadcrumbActions";
import {fetchAllCountries} from "../../country-coverage/actions/CountriesActions";
import LastUpdated from "../../../common/partials/LastUpdated";
import Sidebar from "../../../common/components/Sidebar";
import VeritasSidebarButtons from "../../shared/VeritasSidebarButtons";

export class DataProviderDetailPage extends React.Component {

    componentDidMount() {
        const {providerID} = this.props.params;
        this.props.getProviderDetail(providerID);
        // If the application reloads at this point, make an API call
        // to get all the services so that for a possible navigation
        // directly to the KYC or KYB Services List page, the data is
        // loaded for rendering.
        if (this.props.all_services.length === 0) {
            this.props.getAllServices();
        }
        if (this.props.all_countries.length === 0) {
            this.props.getAllCountries();
        }
        if (this.props.all_organizations.length === 0) {
            this.props.getAllOrganizations();
        }
        this.props.setBreadCrumb({
            parent: { url: '/veritas', text: 'Veritas' },
            list: { url: '/veritas/data-providers', text: 'Data Providers' },
            service: { url: '', text: '' },
            source: { url: '', text: '' },
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {providerID} = this.props.params;
        if (this.props.updatedDP) {
            this.props.getProviderDetail(providerID);
            this.props.updatedDPRefresh();
        }
        // On creation of a new DP from a DP detail page, Marvel was not reloading or
        // fetching the data of the newly created DP keeping it on the same old DP Detail Page.
        if (prevProps.params !== this.props.params) {
            this.props.getProviderDetail(providerID);
        }
        document.title = `Veritas - ` + this.props.providerDetail.provider_detail.provider_name;

        this.props.setBreadCrumb({
            parent: { url: '/veritas', text: 'Veritas' },
            list: { url: '/veritas/data-providers', text: 'Data Providers' },
            service: { url: `/veritas/data-providers/${providerID}`, text: this.props.providerDetail.provider_name },
            source: { url: '', text: '' },
        })
    }

    componentWillUnmount() {
        this.props.unmountProviderDetail();
    }

    handleProviderApprovalsButtonClick = () => {
        const {providerDetail} = this.props;
        this.props.toggleApproval("dp", providerDetail.approvals);
    }

    get providerName() {
        const {providerDetail, canEdit, canApprove} = this.props;

        const isApproved = providerDetail.approvals.is_approved
            ? `Approved`
            : `Not Approved`;
        const approvalButtonColor = isApproved === `Not Approved` ? "red" : "green";
        const lastUpdatedOnDate = providerDetail.provider_detail.last_updated;

        return(
            <div className="header-container">
                <div className="title-alignment">
                    <span className="detail-name">
                        <h1>{providerDetail.provider_detail.provider_name}</h1>
                    </span>
                    {canEdit
                        ? (<span className="buttons-alignment">
                            <Popup
                                content={"Edit"}
                                trigger={
                                    <Button
                                        onClick={this.handleEditButtonClick}
                                        icon="edit outline"
                                    />
                                }
                            />
                            <Popup
                                content={"Delete"}
                                trigger={
                                    <Button
                                        onClick={this.deleteButtonClick}
                                        color={"red"}
                                        icon="trash alternate outline"
                                    />
                                }
                            />
                        </span>)
                        : null
                    }
                </div>

                <div className="title-alignment" style={{height: "30px"}}>
                    {canApprove
                        ? (
                            <span className="buttons-alignment">
                                <div className="flex">
                                    <Button
                                        content={isApproved}
                                        color={approvalButtonColor}
                                        onClick={this.handleProviderApprovalsButtonClick}
                                    />
                                    <label> Last Updated On: </label>
                                    <LastUpdated lastUpdated={lastUpdatedOnDate}  />
                                </div>
                            </span>
                            )
                            : null
                        }
                </div>
            </div>
        );
    }

    get pageContent() {
        return (
            <div style={{padding: "20px 20px 0 30px"}}>
                <Grid relaxed={true}>
                    <Grid.Column width={12}>
                        <Breadcrumb />
                        <div style={{ padding: "20px 20px 0 20px" }}>
                            {this.providerName}
                            <ProviderDetailInfo
                                providerDetail={this.props.providerDetail}
                                associatedServices={this.props.associatedServices}
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column width={4}>
                    </Grid.Column>
                </Grid>
            </div>
        )
    };

    handleEditButtonClick = () => {
        const {providerDetail} = this.props;
        this.props.openEditModal("Data Provider", providerDetail);
    }

    handleCloseButtonClick = () => {
        Validation.clearMessages();
        this.props.closeModal("Data Provider");
    }

    handleEditDPSubmit(e) {
        e.preventDefault();
        const { providerObject } = this.props;
        this.props.validateDataProvider(providerObject)
    }

    deleteButtonClick = () => {
        this.props.toggleDPDeleteWarning();
    }

    handleCancelDPDelete = () => {
        this.props.toggleDPDeleteWarning();
    }

    handleConfirmDPDelete = ()=> {
        const {providerDetail} = this.props;
        this.props.deleteCurrentDataProvider(providerDetail.provider_detail.provider_id);
    }

    render() {

        const {editModalOpenDP, dpModalHeader, deleteDPWarning, providerDetail} = this.props;
        const confirmMessage = `Are you sure you want to delete ${providerDetail.provider_name} ?
        This action cannot be undone.`
        return (
            <div className="veritas">
                <VeritasHeader />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <VeritasSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        {this.pageContent}
                    </Grid.Column>

                    <Modal
                        centered={false}
                        dimmer="blurring"
                        open={editModalOpenDP}
                    >
                        <Modal.Header>
                            {dpModalHeader}
                        </Modal.Header>
                        <Modal.Content scrolling>
                            <DataProviderForm />
                        </Modal.Content>
                        <Modal.Actions>
                            <Button type="button" color="red" inverted onClick={this.handleCloseButtonClick}>
                                Close
                            </Button>
                            <Button color="green" inverted type="submit" onClick={e => this.handleEditDPSubmit(e)}>
                                Submit
                            </Button>
                        </Modal.Actions>
                    </Modal>

                    <Confirm
                        open={deleteDPWarning}
                        content={confirmMessage}
                        onCancel={this.handleCancelDPDelete}
                        onConfirm={this.handleConfirmDPDelete}
                    />

                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    canEdit: state.marvel.user.access.accessLevel.isDPEditor,
    canApprove: state.marvel.user.access.accessLevel.isDPAdmin,
    all_services: state.veritas.services.all_services,
    all_providers: state.veritas.providers.all_providers,
    all_organizations: state.veritas.providers.all_organizations,
    all_countries: state.veritas.countries.all_countries,

    editModalOpenDP: state.veritas.addEdit.addEditDP.editModalOpenDP,
    providerObject: state.veritas.addEdit.addEditDP.providerObject,
    updatedDP: state.veritas.addEdit.addEditDP.updatedDP,
    dpModalHeader: state.veritas.addEdit.addEditDP.dpModalHeader,

    providerDetail: state.veritas.providerDetail.dataProvider,
    associatedServices: state.veritas.providerDetail.associatedServices,
    deleteDPWarning: state.veritas.providerDetail.deleteDPWarning,
});

const mapDispatchToProps = dispatch => ({
    getAllServices: () => { dispatch(fetchAllServices()) },
    getAllCountries: () => {dispatch(fetchAllCountries())},
    getAllOrganizations: () => { dispatch(fetchAllOrganizations()) },
    getProviderDetail: (providerID) => { dispatch(fetchOneDataProvider(providerID)) },

    openEditModal: (type, detailObject) => { dispatch(openEditModal(type, detailObject)) },
    closeModal: (type) => { dispatch(closeAddEditModal(type)) },
    validateDataProvider: (providerObject) => { dispatch(validateDataProvider(providerObject)) },
    updatedDPRefresh: () => { dispatch(updatedDPRefresh()) },
    toggleDPDeleteWarning: () => { dispatch(toggleDeleteWarning()) },
    deleteCurrentDataProvider: (dpID) => { dispatch(deleteDataProvider(dpID)) },
    unmountProviderDetail: () => { dispatch(unmountDataProviderDetail()) },
    toggleApproval: (type, approvalsObject) => { dispatch(toggleApproval(type, approvalsObject)) },
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DataProviderDetailPage)
